<template>
	<div>
		<sub-dialog ref="dialog" :title="titleName" width="1200">
			<div class="flex-column">
				<sub-operate>
					<sub-button color="sys" icon="add" @click="addHandle(0)">新增导航</sub-button>
				</sub-operate>

				<sub-table ref="table" :paging="false" height="400">
				  <sub-table-column
					  type="expand"
					  label="导航名称"
					  name="name"
					  add-button="添加子导航"
					  expand-limit="2"
					  width="110"
					  @expand="loadChildren"
					  @add="addHandle"
				  >
				  </sub-table-column>

				  <sub-table-column
					  label="标签文字"
					  name="tag_name"
				  ></sub-table-column>

				  <sub-table-column
					  label="标签颜色"
					  name="tag_color"
				  ></sub-table-column>

				  <sub-table-column
					  label="跳转链接"
					  name="link_params"
					  width="150"
				  >
					<template v-slot="{data}">
						{{sub.parseLink(data.link_params)}}
					</template>
				  </sub-table-column>

				  <sub-table-column
					  type="sort"
					  label="排序"
					  @sort="sortHandle"
				  ></sub-table-column>

				  <sub-table-column
					  type="button"
					  fixed="right"
					  label="操作"
					  width="110"
				  >
					<template v-slot="row">
					  <sub-table-button @click="editHandle(row)">编辑</sub-table-button>
					  <sub-table-button @click="deleteHandle(row)">删除</sub-table-button>
					</template>
				  </sub-table-column>
				</sub-table>
			</div>
		</sub-dialog>
		
		<sub-dialog ref="editDialog" :title="editState ? '编辑导航' : '添加导航'" width="600" height="300" @resolve="addChild">
			<sub-form ref="form">
				<sub-form-item type="input" label="导航名称" name="name" required></sub-form-item>
				<sub-form-item type="link" label="导航链接" name="link_params" required link-type="pc" :link-template="template_id"></sub-form-item>
				<sub-form-item type="input" label="标签文字" name="tag_name"></sub-form-item>
				<sub-form-item type="color" label="标签颜色" name="tag_color"></sub-form-item>
			</sub-form>
		</sub-dialog>
	</div>
</template>

<script>

export default {
  data() {
    return {
      template_id:0,
      titleName:'导航管理',
      editState: false,
      editLevel: 0
    }
  },

  methods: {
    initTable(){
      this.$refs.table.load({
        url: '/decoration/nav/list',
        data: {
          template_id: this.template_id,
          parent_id: 0
        }
      });
    },
    open(title_name,template_id){
      if (title_name) {
          this.titleName = title_name;
      }
      if (template_id) {
          this.template_id = template_id;
      }
      this.initTable();
      this.$refs.dialog.open();
    },

    loadChildren(row, resolve) {
      this.request({
        url: '/decoration/nav/list',
        data: {
          template_id: this.template_id,
          parent_id: row.data.id
        },
        success: data => {
          resolve(data);
        }
      });
    },

    addHandle(row, resolve) {
      this.editState = false;
      this.editLevel = row ? row.expandData.level + 1 : 0;
      this._edit = 0;
      this._parent = row ? row.data.id : 0;
      this._resolve = data => {
        row ? resolve(data) : this.$refs.table.push(data);
      };
      this.$refs.form.clear();
      this.$refs.editDialog.open();
    },

    editHandle(row) {
      this.editState = true;
      this.editLevel = row.expandData.level;
      this._edit = row.data.id;
      this._parent = row.expandData.parent ? row.expandData.parent.data.id : 0;
      this._resolve = data => {
        row.update(data);
      };
      this.$refs.form.set(row.data);
      this.$refs.editDialog.open();
    },

    deleteHandle(row) {
      this.sub.$confirm({
        text: '确定要删除导航【'+row.data.name+'】吗？',  // 提示内容,
        buttonName: '确定',  // 确定按钮文字
        cancelButton: true,  // 是否显示取消按钮
        resolve: () => {
          this.request({
            url: '/decoration/nav/remove',
            data: {
              template_id: this.template_id,
              id: row.data.id
            },
            loading: true,
            success: data => {
              this.sub.$message({
                text: '删除成功'
              });
              row.remove();
            }
          });
        },  // 确定按钮回调
        cancel: () => {},  // 取消按钮回调
      });
    },

    sortHandle(row, type, next) {
      this.request({
        url: '/decoration/nav/sort',
        data: {
          template_id: this.template_id,
          id: row.data.id,
          parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
          sort_type: type
        },
        loading: true,
        success: data => {
          next();
        }
      });
    },

    addChild(stop) {
      stop();
      var data = this.$refs.form.serialize();
      if (!data.name) {
        this.sub.$message({
          text: '请填写导航名称'
        });
        return;
      }
      if (!data.link_params) {
        this.sub.$message({
          text: '请填写导航链接'
        });
        return;
      }
      this.request({
        url: '/decoration/nav/edit',
        data: Object.assign(data, {
          template_id: this.template_id,
          id: this._edit,
          parent_id: this._parent
        }),
        loading: true,
        success: data => {
          this.sub.$message({
            text: this._edit ? '编辑成功' : '添加成功'
          });
          this.$refs.editDialog.close();
          this._resolve(data);
        }
      });
    }
  }
}
</script>